
import { Vue, Component, Prop, Model } from "vue-property-decorator";

@Component
export default class StarRating extends Vue {
  @Model("input", { type: Number, default: 1 }) readonly value!: number;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  hoverRating = 0;

  get ratingText() {
    const rating = this.hoverRating || this.value;
    const texts = {
      1: "1 star - Poor",
      2: "2 stars - Fair", 
      3: "3 stars - Good",
      4: "4 stars - Very Good",
      5: "5 stars - Excellent"
    };
    return texts[rating as keyof typeof texts] || "";
  }

  setRating(rating: number) {
    if (!this.disabled) {
      this.$emit("input", rating);
    }
  }
}
